export default __webpack_public_path__ + "static/media/myTeam.66871013.svg";